 (function($) {


     // $('.item-img').on('change', function () {
     //     imageId = $(this).data('id');
     //     tempFilename = $(this).val();
     //     $('#cancelCropBtn').data('id', imageId);
     //     readFile(this);
     // });
     //
     // function readFile(input) {
     //     if (input.files && input.files[0]) {
     //         if (checkImage(input.files[0])) {
     //             var reader = new FileReader();
     //             reader.onload = function (e) {
     //                 $('.upload-demo').addClass('ready');
     //                 $('#cropImagePop').modal('show');
     //                 rawImg = e.target.result;
     //             }
     //             reader.readAsDataURL(input.files[0]);
     //         }
     //     }
     // }

     FormValidation.Validator.avatarSize = {
                 /**
                   * @param {FormValidation.Base} validator The validator plugin instance
                   * @param {jQuery} $field The jQuery object represents the field element
                   * @param {Object} options The validator options
                   * @returns {Boolean}
                   */
                 validate: function(validator, $field, options) {



                     var  files = $field.get(0).files;
                     var img = new Image();
                     var answer;
                     img.onload = function() {
                             var w = this.width,
                                     h = this.height;

                        if(w!=h){

                                answer="false";
                                // d.resolve(answer);
                                    return false
                                } else {
                                answer="true";

                                // d.resolve(answer);
                                return true
                                }
                         };
                     var reader = new FileReader();
                     reader.readAsDataURL(files[0]);
                     reader.onloadend = function(e) {
                             img.src = reader.result;
                         };


                 // console.log($field.val())
                     //             var img  = new Image();
                     //             img.onload = function () {
                     //                 console.log("Width:"   this.width   "   Height: "   this.height);//this will give you image width and height and you can easily validate here....
                     //
                     //                 return this.width >= param
                     //             };
                     //             img.src =  _URL.createObjectURL($field.val());



                     // return true if the field value is valid
                     // otherwise return false
                                                                             }
         };

     }(window.jQuery));


$('document').ready(function () {
    var url = window.location.href;
    if (url.indexOf('Edit') + 1) {
        $('#employerForm').formValidation({
            framework: 'bootstrap',
            fields: {
                avatar: {
                    validators: {
                        file: {
                            extension: 'jpeg,jpg,png,eps,tiff,bmp',
                            type: "image/jpeg,image/pjpeg,image/png,application/postscript,image/tiff,image/x-tiff,image/bmp,image/x-windows-bmp",
                            maxSize: 20 * 1024 * 1024,
                            message: 'The file must be in .jpeg, .jpg, .png, .eps, .tiff, .bmp format and must not exceed 20MB in size'
                        }
                    }
                }
            }
        }).on("err.form.fv", () => {
            // checkCheckboxes($(".industry"), $(".error-industry"));
        var invalidField = $("#employerForm").find(".help-block:visible").eq(0);
        var formGroup = invalidField.parents('.form-group');

        // scroll to it
        if (typeof formGroup !== 'undefined') {
            $('html, body').animate({
                scrollTop: formGroup.offset().top
            }, 300);
        }
    }).on('success.form.fv', function () {
            // checkCheckboxes($(".industry"), $(".error-industry"));
        })
        ;

        $('#addCandidate').formValidation({
            framework: 'bootstrap',
            fields: {
                avatar: {
                    validators: {
                        file: {
                            extension: 'jpeg,jpg,png,eps,tiff,bmp',
                            type: "image/jpeg,image/pjpeg,image/png,application/postscript,image/tiff,image/x-tiff,image/bmp,image/x-windows-bmp",
                            maxSize: 20 * 1024 * 1024,
                            message: 'The file must be in .jpeg, .jpg, .png, .eps, .tiff, .bmp format and must not exceed 20MB in size'
                        }
    //                     avatarSize:{
    //                         message: 'Width and height of the uploaded image must be equal'
    // }

                    }
                },
                insurance: {
                    validators: {
                        file: {
                            extension: 'jpeg,jpg,png,eps,tiff,bmp,pdf',
                            type: "image/jpeg,image/pjpeg,image/png,application/postscript,image/tiff,image/x-tiff,image/bmp,image/x-windows-bmp,application/pdf",
                            maxSize: 20 * 1024 * 1024,
                            message: 'The file must be in .jpeg, .jpg, .png, .eps, .tiff, .bmp, .pdf format and must not exceed 20MB in size'
                        },
                        callback: {
                            callback: function (value, validator, $field) {
                                if($field.siblings(".help-block:visible").attr("data-fv-result")=='INVALID'){
                                    setTimeout(function(){
                                        $('#addCandidate').data('formValidation').resetField($field);
                                        $field.val("");
                                    }, 2000);
                                }
                                return true;
                            }
                        }

                    }
                },
                // "skils[2]": {
                //     validators: {
                //         notEmpty: {
                //             message: 'Field does not match the required format'
                //         },
                //         stringLength: {
                //             message: 'Field content must be less than 100 characters',
                //             max: function (value, validator, $field) {
                //                 return 100 - (value.match(/\r/g) || []).length;
                //             }
                //         }
                //
                //     }
                // }
            }
        })
            .on('success.form.fv', function () {
                // checkCheckboxes($(".skils"), $(".error-skils"));
                // checkCheckboxes($(".consult-skils"), $(".error-consult"));
            })
            .on("err.form.fv", () => {
                // checkCheckboxes($(".skils"), $(".error-skils"));
        var invalidField = $("#addCandidate").find(".help-block:visible").eq(0);
        var formGroup = invalidField.parents('.form-group');

        // scroll to it
        if (typeof formGroup !== 'undefined') {
            $('html, body').animate({
                scrollTop: formGroup.offset().top
            }, 300);
        }
    });
    }
    else {
        $('#employerForm').formValidation({
            autoFocus: false,
            framework: 'bootstrap',
            fields: {
                'project-account[email]': {
                    verbose: false,
                    // trigger:"blur",
                    validators: {
                        remote: {
                            type: 'POST',
                            headers: {
                                'X-CSRF-TOKEN': window.Laravel.csrfToken
                            },
                            url: "/Register/checkemail",
                            name: 'email',
                            data: {email: $('.email').val()},
                            dataType: 'json',
                            validKey: 'is_valid',
                            message: "This email already exists in the database. <span class='reset-field'><a data-toggle='modal' href='#window-reset'>Reset password?</a></span>"
                        }
                    }
                },
                avatar: {
                    validators: {
                        file: {
                            extension: 'jpeg,jpg,png,eps,tiff,bmp',
                            type: "image/jpeg,image/pjpeg,image/png,application/postscript,image/tiff,image/x-tiff,image/bmp,image/x-windows-bmp",
                            maxSize: 20 * 1024 * 1024,
                            message: 'The file must be in .jpeg, .jpg, .png, .eps, .tiff, .bmp format and must not exceed 20MB in size'
                        }
                    }
                }
            }
        }).on('success.form.fv', function () {
            // checkCheckboxes($(".industry"), $(".error-industry"));
        }).on("err.form.fv", (e) => {
            // checkCheckboxes($(".industry"), $(".error-industry"));

        var invalidField = $("#employerForm").find(".help-block:visible").eq(0);
        var formGroup = invalidField.parents('.form-group');

        // scroll to it
        if (typeof formGroup !== 'undefined') {
            $('html, body').animate({
                scrollTop: formGroup.offset().top
            }, 300);
        }
        });

        $('#addCandidate').formValidation({
            framework: 'bootstrap',
            fields: {
                'user_info[email]': {
                    verbose: false,
                    // trigger:"blur",
                    validators: {
                        remote: {
                            type: 'POST',
                            headers: {
                                'X-CSRF-TOKEN': window.Laravel.csrfToken
                            },
                            url: "/Register/checkemail",
                            name: 'email',
                            data: {email: $('.email').val()},
                            dataType: 'json',
                            validKey: 'is_valid',
                            message: "This email already exists in the database. <span class='reset-field'><a data-toggle='modal' href='#window-reset'>Reset password?</a></span>"
                        }
                    }
                },

                avatar: {
                    validators: {
                        file: {
                            extension: 'jpeg,jpg,png,eps,tiff,bmp',
                            type: "image/jpeg,image/pjpeg,image/png,application/postscript,image/tiff,image/x-tiff,image/bmp,image/x-windows-bmp",
                            maxSize: 20 * 1024 * 1024,
                            message: 'The file must be in .jpeg, .jpg, .png, .eps, .tiff, .bmp format and must not exceed 20MB in size'
                        }
                        ,
                        // avatarSize:{
                        //     message: 'Width and height of the uploaded image must be equal'
                        // }
                        // promise: {
                        //     promise: function(value, validator, $field) {
                        //         var dfd   = new $.Deferred(),
                        //             files = $field.get(0).files;
                        //
                        //         if (!files.length || typeof FileReader === 'undefined') {
                        //             dfd.resolve({ valid: true });
                        //             return dfd.promise();
                        //         }
                        //
                        //         var img = new Image();
                        //         img.onload = function() {
                        //             var w = this.width,
                        //                 h = this.height;
                        //
                        //             dfd.resolve({
                        //                 valid: (w <= 300 && h <= 300),
                        //                 message: 'The avatar width and height must be less than 300 px',
                        //                 source: img.src,    // We will use it later to show the preview
                        //                 width: w,
                        //                 height: h
                        //             });
                        //         };
                        //         img.onerror = function() {
                        //             dfd.reject({
                        //                 message: 'Please choose an image'
                        //             });
                        //         };
                        //
                        //         var reader = new FileReader();
                        //         reader.readAsDataURL(files[0]);
                        //         reader.onloadend = function(e) {
                        //             img.src = e.target.result;
                        //         };
                        //
                        //         return dfd.promise();
                        //     }
                        // }

                    }
                },
                insurance: {
                    validators: {
                        file: {
                            extension: 'jpeg,jpg,png,eps,tiff,bmp,pdf',
                            type: "image/jpeg,image/pjpeg,image/png,application/postscript,image/tiff,image/x-tiff,image/bmp,image/x-windows-bmp,application/pdf",
                            maxSize: 20 * 1024 * 1024,
                            message: 'The file must be in .jpeg, .jpg, .png, .eps, .tiff, .bmp, .pdf format and must not exceed 20MB in size'
                        },
                        callback: {
                            callback: function (value, validator, $field) {
                                if($field.siblings(".help-block:visible").attr("data-fv-result")=='INVALID'){
                                    setTimeout(function(){
                                        $('#addCandidate').data('formValidation').resetField($field);
                                        $field.val("");
                                    }, 2000);
                                }
                                return true;
                            }
                        }
                    }
                },
                "user_info[position]": {
                    validators: {
                        notEmpty: {
                            message: 'Field does not match the required format'
                        },
                        stringLength: {
                            message: 'Field content must be less than 100 characters',
                            max: function (value, validator, $field) {
                                return 100 - (value.match(/\r/g) || []).length;
                            }
                        }

                    }
                }
            }
        })
            .on('success.form.fv', function () {
                // checkCheckboxes($(".skils"), $(".error-skils"));
                // checkCheckboxes($(".consult-skils"), $(".error-consult"));
            })
            .on("err.form.fv", () => {
                // checkCheckboxes($(".skils"), $(".error-skils"));
        var invalidField = $("#addCandidate").find(".help-block:visible").eq(0);
        var formGroup = invalidField.parents('.form-group');

        // scroll to it
        if (typeof formGroup !== 'undefined') {
            $('html, body').animate({
                scrollTop: formGroup.offset().top
            }, 300);
        }
    });

    }
    // $('#addCandidate').find('[id="MQVP-number"]')
    //     .intlTelInput({
    //         autoPlaceholder: true,
    //         onlyCountries: ['au', 'nz'],
    //         utilsScript: '/js/app.js'
    //     });

    $('#projectRegister').formValidation();

    $('#login-form').formValidation();

    $('#candidate-home-form').formValidation();

    //==========for admin panel============
    $("#admin .email-data").formValidation();

    $("#admin .change-form").formValidation();
//========================================================

    // $('#employerForm').find('[id="CPA-phone"]')
    //     .intlTelInput({
    //         autoPlaceholder: true,
    //         onlyCountries: ['au', 'nz'],
    //         utilsScript: '/js/app.js'
    //     });

//=========================================================
    $('#projectRegister').formValidation().on("err.form.fv", () => {
        checkCheckboxes($(".homepage-employer-sap"), $(".error-homepage-employer-sap")
        )
        ;
    var invalidField = $("#projectRegister").find(".help-block:visible").eq(0);
    var formGroup = invalidField.parents('.form-group');

    // scroll to it
    if (typeof formGroup !== 'undefined') {
        $('html, body').animate({
            scrollTop: formGroup.offset().top
        }, 300);
    }
})
    ;

    $('#createProject').formValidation()
        .on("err.form.fv", () => {
            // checkCheckboxes($(".inputPosition"), $(".error-position"));
            validCalendar();
    var invalidField = $("#createProject").find(".help-block:visible").eq(0);
    var formGroup = invalidField.parents('.form-group');

    // scroll to it
    if (typeof formGroup !== 'undefined') {
        $('html, body').animate({
            scrollTop: formGroup.offset().top
        }, 300);
    }

}).on('success.form.fv', function () {
        // checkCheckboxes($(".inputPosition"), $(".error-position"));
        validCalendar();
    })
    ;

    $('#duration').change(function () {
        // if($('#duration').is(':checked')){
            $(".calendar-error").hide();
            removeDisabledBtn()

        // }
    });

    function validCalendar() {

        if(document.getElementById('createProject') && !$( "#contract" ).prop('checked')&&$( "#duration" ).prop('checked')){
         return false;
        }

        var fullDate = $(".infoDate").val();

        fullDate = JSON.parse(fullDate);

        var tmp=0;
        jQuery.each(fullDate[0]["Data"], function(i, val) {
            if(val["status"]=="green"){
                tmp=1;
            }
        });

        if (!tmp) {
            $(".calendar-error").show();
            addDisabledBtn()
        } else {
            $(".calendar-error").hide();
            if (!$(".button-cloud.regProdject").attr("disabled")) {
                removeDisabledBtn()
            }


        }
    }

//==========================functions==================
    function addDisabledBtn() {
        $(".button-cloud").attr("disabled", "disabled");
    };

    function removeDisabledBtn() {
        $(".button-cloud").removeAttr("disabled");
        $(".button-cloud").removeClass("disabled");
    };

    addError = (field, fieldError) => {
        field.addClass("er");
        field.parent(".form-group").removeClass("has-success").addClass("has-error");
        fieldError.show();
        field.siblings(".glyphicon-ok").addClass("glyphicon-er");
        addDisabledBtn();
    }
    ;

    removeError = (field, fieldError) => {
        field.removeClass("er");
        field.parent(".form-group").addClass("has-success").removeClass("has-error");
        field.siblings(".glyphicon-ok").removeClass("glyphicon-er");
        fieldError.hide();
        removeDisabledBtn();
    }
    ;

    checkEmailForgot = () => {
        let data = {
            user_email: $("#forgotPassword input[name='user_email']").val()
        };
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': window.Laravel.csrfToken
            },
            url: "/reset_password",
            data: data,
            dataType: 'json',
            type: 'POST',
            success: function (result) {
                if (result['answer'] == 'ok') {
                    $('#forgotPassword .server-error').hide();
                    $('#forgotPassword .okEmail').show();
                } else {
                    $('#forgotPassword .okEmail').hide();
                    $('#forgotPassword .server-error').show();
                }
            }
        });
    }
    ;

    checkEmailReset = () => {
        let data = {
            user_email: $("#resetPassword input[name='user_email']").val()
        };
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': window.Laravel.csrfToken
            },
            url: "/reset_password",
            data: data,
            dataType: 'json',
            type: 'POST',
            success: function (result) {
                if (result['answer'] == 'ok') {
                    $('#resetPassword .server-error').hide();
                    $('#resetPassword .okEmail').show();
                } else {
                    $('#resetPassword .okEmail').hide();
                    $('#resetPassword .server-error').show();
                }
            }
        });
    }
    ;

    checkLogin = () => {
        $(".loader").fadeIn(500);
        let data = {
            email: $("#login-form input[name='email']").val().trim(),
            password: $("#login-form input[name='password']").val()
        };
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': window.Laravel.csrfToken
            },
            url: "/Register/checklogin",
            data: data,
            dataType: 'json',
            type: 'POST',
            success: function (result) {
                if (result["status"] == 'error') {
                    $('#login-form .server-error').show();
                    $(".loader").fadeOut(500);

                } else {
                    $('#login-form .server-error').hide();
                    if(result["role"]=='candidate'){
                        window.location.replace("/profile/cand_projects");
                    }else if(result["role"]=='admin'){
                        window.location.replace("/Profile");
                    }else if(result["role"]=='employer'){
                        window.location.replace("/profile/projects");
                    }

                }
            }
        });
    }
    ;


    checkCheckboxes = (field, error) => {

        if (!field.is(':checked')) {
            addDisabledBtn();
            error.show();
            return false

        } else {
            removeDisabledBtn();
            error.hide();
            return true
        }

    };
//======================events======================
//     $(".button-cloud.open-panel").click(function(e){
//
//         // $("#panel-1").collapse("show");
//         // $("#panel-6").collapse("show");
//         // checkCheckboxes($(".skils"), $(".error-skils"));
//         // checkCheckboxes($(".consult-skils"), $(".error-consult"));
//         var id = $(this).attr("href");
//         if(id == "#personal_details" || id=="#skill_details" || id == "#availability_details"){
//             $('#addCandidate').data('formValidation').validate();
//             console.log(9999)
//             isValid = $('#addCandidate').data('formValidation').isValid();
//
//             if (isValid) {
//                 $('a[href="'+id+'"]').tab('show');
//             }
//         }else{
//             $('a[href="'+id+'"]').tab('show');
//             $("#addCandidate button.button-cloud").prop("disabled", false);
//         }
//         // $("#addCandidate small[data-fv-result='INVALID']").parent().get(0).scrollIntoView();
//     });


    // employerForm


    $('#addCandidate .cloud-1').click( function (e) {

        // $("#panel-1").collapse("show");
        // $("#panel-6").collapse("show");
        // checkCheckboxes($(".skils"), $(".error-skils"));
        // checkCheckboxes($(".consult-skils"), $(".error-consult"));
        $('#MQVP-email').trigger('click');
        var id = $(this).attr("href");
        if(id=="#skill_details" || id=="#availability_details"){
            $('#addCandidate').data('formValidation').validate();
            setTimeout(function() {

                var isValid = $('#addCandidate').data('formValidation').isValid();

                if (isValid) {
                    $('a[href="'+id+'"]').tab('show');
                    $('#addCandidate .button-cloud').prop('disabled', false);

                    if(id == "#availability_details"){
                        $(".People-Account .step").removeClass("step");
                    }
                }
            }, 1500);
        }else{
            $('a[href="'+id+'"]').tab('show');
            $("#addCandidate button.button-cloud").prop("disabled", false);
        }
        // $("#addCandidate small[data-fv-result='INVALID']").parent().get(0).scrollIntoView();
    });

    //===============tabs==========================
    $('#addCandidate .nav-tabs a').click( function (e) {
        $('#MQVP-email').trigger('click');
        var currTab = $("#addCandidate .tab-content .tab-pane.active").attr("id");
        var id = $(this).attr("href");

        if(currTab=="skill_details" ||  currTab=="personal_details"){
            $('#addCandidate').data('formValidation').validate();
            setTimeout(function() {
                var isValid = $('#addCandidate').data('formValidation').isValid();

                if (isValid) {
                    $('a[href="'+id+'"]').tab('show');
                    $('#addCandidate .button-cloud').prop('disabled', false);

                    if(id == "#availability_details"){
                        $(".People-Account .step").removeClass("step");
                    }
                }
            }, 1500);
        }else{
            $('a[href="'+id+'"]').tab('show');
            $("#addCandidate button.button-cloud").prop("disabled", false);
        }
    });
    // =========================================================================================

    $('#employerForm .cloud-1').click( function (e) {
        var id = $(this).attr("href");
        if(id == "#availability_details" || id=="#skill_details"){
            $('#employerForm').data('formValidation').validate();
            var a =      $('#employerForm').data('formValidation').validate();
            setTimeout(function() {
                var isValid = $('#employerForm').data('formValidation').isValid();
                if (isValid) {
                    $('a[href="'+id+'"]').tab('show');
                    $('#employerForm .button-cloud').prop('disabled', false);

                    if(id == "#availability_details"){
                        $(".Create-Prj-Account .step").removeClass("step");
                    }
                }
            }, 1500);

        } else {
            $('a[href="'+id+'"]').tab('show');
            $("#employerForm button.button-cloud").prop("disabled", false);
        }
    });
//===============tabs==========================
    $('#employerForm .nav-tabs a').click( function (e) {
        var currTab = $("#employerForm .tab-content .tab-pane.active").attr("id");
        var id = $(this).attr("href");

        if(currTab=="skill_details" ||  currTab=="personal_details"){
            $('#employerForm').data('formValidation').validate();
            setTimeout(function() {
                var isValid = $('#employerForm').data('formValidation').isValid();
                if (isValid) {
                    $('a[href="'+id+'"]').tab('show');
                    $('#employerForm .button-cloud').prop('disabled', false);
                }
            }, 1500);
        }else{
            $('a[href="'+id+'"]').tab('show');
            $("#employerForm button.button-cloud").prop("disabled", false);
        }
    });

   //  $(".button-cloud.registrEmp").click(() => {
   //
   //      // checkCheckboxes($(".industry"), $(".error-industry"));
   //      $('#employerForm').data('formValidation').validate();
   //      $("#employerForm small[data-fv-result='INVALID']").parent().get(0).scrollIntoView();
   //
   //
   //  isValid =  $('#employerForm').data('formValidation').isValid();
   // if(isValid){
   //
   //     $(".loader").fadeIn("slow", function () {
   //         $body.addClass("loading");
   //     });
   // }
   //  });

    $(".button-cloud.regProdject").click((e) => {
        if(!$('#duration').is(':checked')){
        var fullDate = $(".infoDate").val();
        fullDate = JSON.parse(fullDate);
        var tmp = 0;
        jQuery.each(fullDate[0]["Data"], function (i, val) {
            if (val["status"] == "green") {
                tmp = 1;
            }
        });

        if (!tmp) {
            e.preventDefault();
            validCalendar();
            $('#createProject').data('formValidation').validate();
        }
    }
    $("#createProject small[data-fv-result='INVALID']").parent().get(0).scrollIntoView();
    });

    $('#login-form .btn').click(() => {
        checkLogin();
    })
    ;

    $("#login-form").keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            checkLogin();
        }
    });

    $('#forgotPassword .btn').click(() => {
        checkEmailForgot();
    })
    ;
    $('#resetPassword .btn').click(() => {
        checkEmailReset();
})
    ;

    $("#forgotPassword").keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            checkEmailForgot();
        }
    });
    $("#resetPassword").keydown(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            checkEmailReset();
        }
    });

    $(".linkForgotPassword").click(() => {
        $('.server-error').hide();
        $('.okEmail').hide();
        $("#forgotPassword")[0].reset();
    })
    ;

    //
    // $(".consult-skils").click(() => {
    //   checkCheckboxes($(".consult-skils"), $(".error-consult")
    //   )
    //   ;
    // })
    // ;


    $(".homepage-employer-sap").click(() => {
        checkCheckboxes($(".homepage-employer-sap"), $(".error-homepage-employer-sap")
        )
        ;
    })
    ;

    $(".sap_solution").click(() => {
        checkCheckboxes($(".sap_solution"), $(".error-sap")
        )
        ;
    })
    ;
// =============Level on register project=================================
    // $(".inputPosition").click(() => {
    //     checkCheckboxes($(".inputPosition"), $(".error-position")
    //     )
    //     ;
    // })
    ;


    $('#contactUsForm').formValidation();
    $('#forgotPassword').formValidation();
    $('#resetPassword').formValidation();

    $('#checkEmailReset').formValidation();

    $('#CPA-budget-range-min').unbind();
    $('#CPA-budget-range-max').unbind();
    $('#LP-post_code').unbind();
    $('#LP-town').unbind();







    //===============================fields: ABN NZBN===================

    $(".check-number").click(function () {
        var abn = $(".forabn input");
        var nzbn = $(".fornzbn input");
        if (!$("#nzbn").prop('checked')) {
            nzbn.removeAttr('required');
            abn.prop('required', true);
        }
        if (!$("#abn").prop('checked')) {
            abn.removeAttr('required');
            nzbn.prop('required', true);
        }
    })

//===================== ��������� ������ ���� � ��������� �� �������� LaunchNewProject ========================


});